import { blogService, BlogListParams } from "@/lib/api/services/blog";

import { useQuery, keepPreviousData } from "@tanstack/react-query";

export function useBlogs(params?: BlogListParams) {
  return useQuery({
    queryKey: ["blogs", params],
    queryFn: () => blogService.getAll(params),
    placeholderData: keepPreviousData,
  });
}

export function useBlogCategories() {
  return useQuery<string[]>({
    queryKey: ["blogs", "categories"],
    queryFn: () => blogService.getCategories(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useBlogBySlug(slug: string) {
  return useQuery({
    queryKey: ["blog", slug],
    queryFn: () => blogService.getBySlug(slug),
    enabled: !!slug,
  });
}
